import graphql__359196f1f7b566b0f5db from "./__generated__/MapSidebarTitle_map.graphql.js";import { graphql, useFragment } from "react-relay";
import { useSelector } from "react-redux";
import classNames from "classnames";

import Subscription from "../Subscriptions/Subscription";
import ShareButtons from "../ShareButtons";
import PageTitle from "../Pages/PageTitle";

const MapSidebarTitle = props => {
  const map = useFragment(MapSidebarTitle_map, props.map);
  const { title, allowSendingNotificationOnContentUpdate } = map;
  const socialSharingEnabled = useSelector(({ styling }) => styling.socialSharingEnabled);

  const shareButtonsContainerClassName = classNames({
    "flex-1": allowSendingNotificationOnContentUpdate,
    "margin-left-xs": allowSendingNotificationOnContentUpdate
  });

  return (
    <PageTitle
      page={map}
      className="map-panel-header"
      subscribable={false}
      shareButtons={false}
      title={title}
    >
      {(allowSendingNotificationOnContentUpdate || socialSharingEnabled) && (
        <div className="d-flex align-items-center margin-top-xs">
          {allowSendingNotificationOnContentUpdate && (
            <Subscription subscribable={map} className="margin-top-xs" />
          )}

          {socialSharingEnabled && (
            <div className={shareButtonsContainerClassName}>
              <ShareButtons className="d-inline-block" />
            </div>
          )}
        </div>
      )}
    </PageTitle>
  );
};

const MapSidebarTitle_map = graphql__359196f1f7b566b0f5db;

export default MapSidebarTitle;
